import DiplomaRegisterNumberPage from "./DiplomaRegisterNumberPage";

export default DiplomaRegisterNumberPage